import type { App } from 'vue'
import type { I18n } from 'vue-i18n'
import { useOrganizationStore } from '@/stores/organization.store'

const I18N_TYPE_BY_ORGANIZATION_TYPE: Record<string, string> = {
  business: 'default',
  edu_lp: 'education_sl',
  edu_sus: 'education_lp',
  default: 'default',
  education_sl: 'education_sl',
  education_lp: 'education_lp',
  lumia: 'lumia',
}

const resolveI18nOrganizationType = (): string => {
  const organizationStore = useOrganizationStore()
  const fromOrganization = organizationStore.organizations.find(
    (organization) => organization.id === organizationStore.currentOrganizationId,
  )?.organizationType
  const orgTypeFromQuery = new URLSearchParams(window.location.search).get('org_type') ?? undefined
  const rawType = fromOrganization || orgTypeFromQuery

  if (rawType && rawType in I18N_TYPE_BY_ORGANIZATION_TYPE) {
    return I18N_TYPE_BY_ORGANIZATION_TYPE[rawType]
  }

  return 'default'
}

const resolveKey = (key: string, i18n: I18n): string => {
  const type = resolveI18nOrganizationType()

  const specificKey = `${key}.${type}`

  if (i18n.global.te(specificKey)) {
    return specificKey
  }

  const defaultKey = `${key}.default`

  if (i18n.global.te(defaultKey)) {
    return defaultKey
  }

  return key
}

export const installOrgAwareTranslationHook = (app: App, i18n: I18n) => {
  const originalT = i18n.global.t.bind(i18n.global) as (...params: unknown[]) => unknown

  const orgAwareTranslate = ((key: string, ...args: unknown[]) => {
    if (typeof key !== 'string') {
      return originalT(key, ...args)
    }

    const resolvedKey = resolveKey(key, i18n)
    return originalT(resolvedKey, ...args)
  }) as typeof i18n.global.t

  i18n.global.t = orgAwareTranslate
  app.config.globalProperties.$t = orgAwareTranslate
}
